import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import config from '../config';

interface FavoriteButtonProps {
  placeId: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ placeId }) => {
  const [isFavorite, setIsFavorite] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Obtener información del usuario del localStorage
  const userInfo: any = JSON.parse(localStorage.getItem("usuario") || "{}");
  const userGoogleId = userInfo?.id;

  useEffect(() => {
    const checkFavoriteStatus = async () => {
    console.log("userInfo",userInfo)
      if (!userGoogleId || !placeId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${config.backendUrl}/api/Favoritos/EsFavorito?usuariogoogleId=${userGoogleId}&placeId=${placeId}`
        );
        
        if (!response.ok) {
          throw new Error('Error al verificar favorito');
        }

        const data = await response.json();
        setIsFavorite(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error desconocido');
      } finally {
        setLoading(false);
      }
    };

    checkFavoriteStatus();
  }, [userGoogleId, placeId]);

  const toggleFavorite = async () => {
    if (!userGoogleId || !placeId) return;

    setLoading(true);
    setError(null);

    try {
      if (isFavorite) {
        // Eliminar de favoritos
        const response = await fetch(
          `${config.backendUrl}/api/Favoritos?usuariogoogleId=${userGoogleId}&placeId=${placeId}`,
          {
            method: 'DELETE',
          }
        );

        if (!response.ok) {
          throw new Error('Error al quitar de favoritos');
        }

        setIsFavorite(false);
      } else {
        // Agregar a favoritos
        const response = await fetch(
          `${config.backendUrl}/api/Favoritos?usuariogoogleId=${userGoogleId}&placeId=${placeId}`,
          {
            method: 'POST',
          }
        );

        if (!response.ok) {
          throw new Error('Error al agregar a favoritos');
        }

        setIsFavorite(true);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setLoading(false);
    }
  };

  if (!userGoogleId) {
    return (
      <Tooltip title="Inicia sesión para guardar favoritos"
      disableTouchListener={false}  // Esto habilita el tooltip en dispositivos táctiles
      enterTouchDelay={0}  >
        <span>
          <IconButton disabled>
            <FavoriteBorderIcon />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  if (loading) {
    return <CircularProgress size={24} />;
  }

  if (error) {
    console.error(error);
    return (
      <Tooltip title="Error al cargar favoritos">
        <IconButton color="error" disabled>
          <FavoriteBorderIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isFavorite ? "Quitar de favoritos" : "Agregar a favoritos"}>
      <IconButton
        color={isFavorite ? "error" : "default"}
        onClick={toggleFavorite}
        disabled={loading}
      >
        {isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;